import { render, staticRenderFns } from "./FormDoc.vue?vue&type=template&id=5173bcf6&scoped=true&"
import script from "./FormDoc.vue?vue&type=script&lang=js&"
export * from "./FormDoc.vue?vue&type=script&lang=js&"
import style0 from "./FormDoc.vue?vue&type=style&index=0&id=5173bcf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173bcf6",
  null
  
)

export default component.exports